import { apiUrl } from './api'
import type { OrgViewSide } from './orgViewState'

// Fire-and-forget audit emission for platform-admin org-context enter/exit.
// D-5 Ring 3 governance bypass must be audited (A-25). Real backend writes to
// audit_events (Faz 1) post-resume; V1 appends to the activity log via MSW.

export type OrgContextEvent = {
  type: 'enter' | 'exit'
  side: OrgViewSide
  orgId: string
  orgName: string
  orgType: string
  enteredWith: 'seller' | 'vendor' | 'both'
}

export function postOrgContextEvent(payload: OrgContextEvent): void {
  void fetch(apiUrl('/admin/org-context/event'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).catch(() => {
    // Audit is best-effort in V1 simulation; never block the UX flow.
  })
}
